<template>
<div>
    <div>
        <template v-if="brandsAtdData && brandsAtdData.length">
            <div v-for="(singleAtd) in brandsAtdData" :key="singleAtd.id">
                <div class="atd-card global-border-radius px-sm-3 px-lg-5 px-5 py-5 mb-5" v-if="singleAtd.atd_overview_section">
                    <div class="time_location__wrapper d__flex">
                        <div v-if="singleAtd.atd_overview_section.traning_event_date" class="d__flex date__wrapper">
                            <img class="mr-3 atd-o__image" src="/wp-content/themes/sands-events-subtheme/img/images.png" alt="">
                            <p class="m-0" v-if="singleAtd.display_english_text && singleAtd.display_english_text == '1'">{{getDate(singleAtd.atd_overview_section.traning_event_date,'MMM DD',singleAtd.display_english_text)}} - &nbsp;</p>
                            <p class="m-0" v-else>{{getDate(singleAtd.atd_overview_section.traning_event_date,'DD',singleAtd.display_english_text)}}. - &nbsp;</p>
                            <p class="m-0"  v-if="singleAtd.display_english_text && singleAtd.display_english_text == '1'">{{getDate(singleAtd.atd_overview_section.traning_event_enddate,'DD, YYYY',singleAtd.display_english_text)}}</p>
                            <p class="m-0" v-else>{{getDate(singleAtd.atd_overview_section.traning_event_enddate,'DD. MMMM YYYY',singleAtd.display_english_text)}}</p>
                        </div>
                        <div v-if="singleAtd.atd_overview_section.location_info" class="d__flex">
                            <img class="mr-3 atd-o__image" v-if="singleAtd.atd_overview_section.location_info == 'Online'" src="/wp-content/themes/sands-events-subtheme/img/remote.png" alt="">
                            <img class="mr-3 atd-o__image" v-if="singleAtd.atd_overview_section.location_info != 'Online' && singleAtd.atd_overview_section.location_name" src="/wp-content/themes/sands-events-subtheme/img/building.png" alt="">
                            <p class="m-0" v-if="singleAtd.atd_overview_section.location_info == 'Online'">Online</p>
                            <p class="m-0" v-if="singleAtd.atd_overview_section.location_info != 'Online' && singleAtd.atd_overview_section.location_name">{{singleAtd.atd_overview_section.location_name}}</p>
                        </div>
                    </div>
                    <div class="btn-prise__wrapper">
                        <div class="d__flex gap-50" v-if="singleAtd.atd_overview_section.starting_price">
                            <div class="starting_price">
                                <span v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1">Prices from:</span>
                                <span v-else> Preise ab:</span>
                                {{singleAtd.atd_overview_section.starting_price}}
                            </div>
                            <a class="atd-outter-button global-border-radius  mlcBasedButtons atd-overview custom-primary-button m-0" :class="randomId" :id="randomId" :style="{ 'background-color': singleAtd.atd_overview_section.btnatd_color, 'color': singleAtd.atd_overview_section.btnatd_text }"  data-toggle="collapse" :data-target="'#' + singleAtd._uniqueId">Info/Tickets</a>
                        </div>
                    </div>
                </div>
                <div :id="singleAtd._uniqueId" class="collapse mb-5 mt-n5 p-5 rounded-l position-relative">
                <span class="close" data-toggle="collapse" :data-target="'#' + singleAtd._uniqueId">×</span>
                    <h3 v-if="singleAtd.traning_camp_name" class="m-0 atd-inner-headline px-4">
                        {{singleAtd.traning_camp_name}}
                    </h3>
                    <div class="f__row flex-wrap mt-5 px-4">
                        <div class='col-12 col-lg-3 col-md-4 left__atd__inner'>
                            <div v-if="singleAtd.atd_expert_info_section && singleAtd.atd_expert_info_section.exp_repeater && singleAtd.atd_expert_info_section.exp_repeater.length" class="hide_on_mobile">
                                <div v-for="(singleExpert, index) in singleAtd.atd_expert_info_section.exp_repeater" :key="index"   :class="{ 'mt-3': index === 0, 'mt-4': index !== 0 }">
                                    <img class="atd-author__image mb-2" v-if="singleExpert.expert_name && singleExpert.expert_image" :src="singleExpert.expert_image" :alt="singleExpert.expert_name">
                                    <h3 class="mt-2 mb-1 atd-subheadline" v-if="singleExpert.expert_name">
                                        {{singleExpert.expert_name}}
                                    </h3>
                                    <div class="m-0" v-if="singleExpert.expert_more_info" v-html="singleExpert.expert_more_info"></div>
                                </div>

                            </div>

                            <div v-if="singleAtd.event_location_and_format">
                                <div class="hidden visible-lg">
                                    <h3 class="mt-5 mb-1  atd-subheadline">Format</h3>
                                    <div class="m-0 format" v-if="singleAtd.event_location_and_format.format_info" v-html="singleAtd.event_location_and_format.format_info">
                                    </div>
                                </div>

                                <!-- location information section  -->
                                <div class="location hide_on_mobile" v-if="singleAtd.event_location_and_format.hotal_name">
                                    <h3 class="mt-5 mb-2  atd-subheadline">
                                        Location
                                    </h3>
                                    <h3 class="mt-2 mb-1  atd-subheadline">
                                        {{singleAtd.event_location_and_format.hotal_name}}
                                    </h3>
                                    <p v-if="singleAtd.event_location_and_format.hotal_address">
                                        {{singleAtd.event_location_and_format.hotal_address}}
                                    </p>
                                    <img v-if="singleAtd.event_location_and_format.hotal_image" class="global-border-radius" :src="singleAtd.event_location_and_format.hotal_image" :alt="singleAtd.event_location_and_format.format_info.hotal_name">
                                    <div v-if="singleAtd.event_location_and_format.room_info_booking_link" v-html="singleAtd.event_location_and_format.room_info_booking_link"></div>
                                </div>
                            </div>

                        </div>

                        <div class="right__atd__inner col-12 col-lg-8 col-md-7 d-flex flex-column">
                            <div v-if="singleAtd.atd_expert_info_section && singleAtd.atd_expert_info_section.expert_image && singleAtd.atd_expert_info_section.expert_name" class='mb-2' style="height: 75px;"></div>
                            <div class='early_bird' v-if="singleAtd.atd_overview_section && singleAtd.atd_overview_section.early_bird" v-html="singleAtd.atd_overview_section.early_bird"></div>
                            <div class="attendees__info">
                                <div class="d-flex flex-wrap teilnehmer__Anzahl teilnehmer hide_on_mobile" v-if="singleAtd.atd_overview_section && singleAtd.atd_overview_section.traning_event_date">
                                    <h4 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1" class="atd-subheadline">Date:</h4>
                                    <h4 v-else class="atd-subheadline">Datum:</h4>
                                    <div class="d-flex flex-wrap">
                                        <p class="m-0" v-if="singleAtd.display_english_text && singleAtd.display_english_text == '1'">{{getDate(singleAtd.atd_overview_section.traning_event_date,'MMM DD',singleAtd.display_english_text)}} - &nbsp;</p>
                                        <p class="m-0" v-else>{{getDate(singleAtd.atd_overview_section.traning_event_date,'DD',singleAtd.display_english_text)}}. - &nbsp;</p>
                                        <p class="m-0"  v-if="singleAtd.display_english_text && singleAtd.display_english_text == '1'">{{getDate(singleAtd.atd_overview_section.traning_event_enddate,'DD, YYYY',singleAtd.display_english_text)}}</p>
                                        <p class="m-0" v-else>{{getDate(singleAtd.atd_overview_section.traning_event_enddate,'DD. MMMM YYYY',singleAtd.display_english_text)}}</p>
                                    </div>

                                </div>
                                <div class="d-flex flex-wrap gap__10 teilnehmer mt-3 flex-sm-column" v-if="singleAtd.general_info_section && singleAtd.general_info_section.Trainingszeiten && singleAtd.general_info_section.Trainingszeiten.length">
                                    <h4 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1" class="mt-1 atd-subheadline">Training schedule:</h4>
                                    <h4 v-else class="mt-1 atd-subheadline">Trainingszeiten:</h4>
                                    <div>
                                        <div v-for="(traningTime, index) in singleAtd.general_info_section.Trainingszeiten" :key="index">
                                            <p v-if="traningTime.trainingszeiten && traningTime.trainingszeitenEnd">{{getFormattedDate(traningTime.trainingszeiten,singleAtd.display_english_text)}}<span> - {{getFormattedTime(traningTime.trainingszeitenEnd,singleAtd.display_english_text)}} <span v-if="singleAtd.display_english_text && singleAtd.display_english_text == '1'"></span> <span v-else>Uhr</span></span></p>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="singleAtd.atd_expert_info_section && singleAtd.atd_expert_info_section.exp_repeater && singleAtd.atd_expert_info_section.exp_repeater.length" class="hide_on_desktop">
                                <div v-for="(singleExpert, index) in singleAtd.atd_expert_info_section.exp_repeater" :key="index"   :class="{ 'mt-3': index === 0, 'mt-4': index !== 0 }">
                                    <img class="atd-author__image mb-2" v-if="singleExpert.expert_name && singleExpert.expert_image" :src="singleExpert.expert_image" :alt="singleExpert.expert_name">
                                    <h3 class="mt-2 mb-1 atd-subheadline" v-if="singleExpert.expert_name">
                                        {{singleExpert.expert_name}}
                                    </h3>
                                </div>

                            </div>
                                <div class="d-flex flex-wrap teilnehmer__Anzahl teilnehmer mt-3 flex-sm-column" v-if="singleAtd.general_info_section.teilnehmer_anzahl && singleAtd.general_info_section.teilnehmer_anzahl >0" >
                                    <h4 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1" class="atd-subheadline">Limited to:</h4>
                                    <h4 v-else class="atd-subheadline">Limitiert auf:</h4>
                                    <h4 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1">{{singleAtd.general_info_section.teilnehmer_anzahl}} Participants </h4>
                                    <h4 v-else>{{singleAtd.general_info_section.teilnehmer_anzahl}} Teilnehmende </h4>
                                </div>
                            </div>




                            <div class='d-flex teilnehmer gap-10 mt-3 flex-sm-column hide_on_mobile' v-if="singleAtd.general_info_section && singleAtd.general_info_section.inhalte_was_bekomme_ich">
                                <h3 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1" class="mt-2 mb-1  atd-subheadline">Program</h3>
                                <h3 v-else class="mt-2 mb-1  atd-subheadline">Inhalt</h3>
                                <div v-if="singleAtd.general_info_section.inhalte_was_bekomme_ich" v-html="singleAtd.general_info_section.inhalte_was_bekomme_ich"></div>
                            </div>
                            <div class="hidden visible-lg d-flex  teilnehmer gap-10 mt-3 flex-sm-column" v-if="singleAtd.general_info_section && singleAtd.general_info_section.voraussetzungen">
                                <h3 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1" class="mt-2 mb-1  atd-subheadline">Requirements</h3>
                                <h3 v-else class="mt-2 mb-1  atd-subheadline"> Voraussetzungen </h3>
                                <div v-if="singleAtd.general_info_section.voraussetzungen && singleAtd.general_info_section.voraussetzungen != ''" v-html="singleAtd.general_info_section.voraussetzungen"></div>
                            </div>
                            <div class="hidden visible-lg d-flex teilnehmer gap-10 mt-3 flex-sm-column" v-if="singleAtd.general_info_section && singleAtd.general_info_section.zertifikat_benefits">
                                <h3 class="mt-2 mb-1  atd-subheadline">Zertifikat / benefits</h3>
                                <div v-if="singleAtd.general_info_section.zertifikat_benefits" v-html="singleAtd.general_info_section.zertifikat_benefits"></div>
                            </div>
                            <!-- location information section mobile-->
                            <div class="location hide_on_desktop" v-if="singleAtd.event_location_and_format.hotal_name">
                                    <h3 class="mt-5 mb-2  atd-subheadline">
                                        Location
                                    </h3>
                                    <h3 class="mt-2 mb-1  atd-subheadline">
                                        {{singleAtd.event_location_and_format.hotal_name}}
                                    </h3>
                                    <p v-if="singleAtd.event_location_and_format.hotal_address">
                                        {{singleAtd.event_location_and_format.hotal_address}}
                                    </p>
                                    <img v-if="singleAtd.event_location_and_format.hotal_image" class="global-border-radius" :src="singleAtd.event_location_and_format.hotal_image" :alt="singleAtd.event_location_and_format.format_info.hotal_name">
                                    <div v-if="singleAtd.event_location_and_format.room_info_booking_link" v-html="singleAtd.event_location_and_format.room_info_booking_link"></div>
                                </div>
                            <!-- iframe section -->
                            <div v-if="singleAtd.iframe_url && singleAtd.iframe_url !=''">
                                <h3 v-if="singleAtd.display_english_text && singleAtd.display_english_text == 1" class="mt-5 mb-5  atd-subheadline">Get your tickets now!</h3>
                                <h3 v-else class="mt-5 mb-5  atd-subheadline">Jetzt Tickets sichern!</h3>
                                <iframe :src="singleAtd.iframe_url" width="100%" frameborder="0" allowfullscreen class='atd-brand__frame'></iframe>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </template>

    </div>

</div>
</template>

<script>
import moment from 'moment';
export default {
    name: "BrandsAtd",
    props: {
        settingsPerm: Object
    },
    created() {
        console.log("BrandsAtd settingsPerm", this.settingsPerm.brand_shortcode_group);
        if (this.settingsPerm && this.settingsPerm.brand_shortcode_group && this.settingsPerm.brand_shortcode_group.length) {
            //we get some data from WP to display
            // this.brandsAtdData = this.settingsPerm.brand_shortcode_group;
            this.brandsAtdData = this.settingsPerm.brand_shortcode_group.map((item, index) => {
                return {
                    ...item,
                    _uniqueId: `brandAtd-${index}-${Math.random().toString(36).substring(2, 15)}`
                };
            });
            this.doWeHavebrandsAtdData = true;
            setTimeout(() => {
                this.calculateWidthOfBiggestDiv();
            }, 1500);
        }
    },
    data() {
        return {
            brandsAtdData: [],
            doWeHavebrandsAtdData: false,
            biggestWidth: '',
            randomId: Math.random().toString(36).substring(7),
            hoverColor: '#2980b9'
        };
    },
    methods: {
        getFormattedDate(date,format) {
            if (format && format == 1) {
                moment.locale('en');
                return moment(date,'DD/MM/YYYY h:mm a').format('dddd,') + ' ' +moment(date,'DD/MM/YYYY h:mm a').format('HH:mm ');
            }else{
                moment.locale('de');
                return moment(date,'DD/MM/YYYY h:mm a').format('dddd,') + ' ' +moment(date,'DD/MM/YYYY h:mm a').format('HH:mm ');
            }
        },
        getFormattedTime(date, format) {
            if (format && format == 1) {
                moment.locale('en');
                return moment(date,'DD/MM/YYYY h:mm a').format('HH:mm ');
            }else{
                moment.locale('de');
                return moment(date,'DD/MM/YYYY h:mm a').format('HH:mm ');
            }
        },
        overViewFormatedDate(date) {
            moment.locale('de');
            return moment(date,'DD/MM/YYYY h:mm a').format('DD. MMMM. YYYY');
        },
        getDate(date, format, language) {
            if (language && language == 1) {
                moment.locale('en');
            }else{
                moment.locale('de');
            }
            return moment(date,'DD/MM/YYYY h:mm a').format(format);
        },

    },
};
</script>

<style lang="css" scoped>
.early_bird img{
    height: 37px; 
    width: 37px;
}
.close{
    font-size: 45px;
    position: absolute;
    right: 20px;
    top: 6px;
}
.gap-10{
    gap: 10px;
}
.position-relative{
    position: relative;
}
.atd-card {
    position: relative;
    display: flex;
    flex-direction: row;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #e9eaeb;
    border-radius: 12px;
    justify-content: space-between;
    font-size: clamp(1.9rem, 1.5vw, 2.5rem);
    line-height: 1.5;
    font-weight: 600;
    gap: 20px;
}

.d__flex {
    display: flex;
    align-items: center;
}

.time_location__wrapper,
.gap-50 {
    gap: 50px;
}

.atd-o__image {
    width: auto;
    height: 30px;
    object-fit: cover;
}

.atd-inner-headline {
    font-size: 34px;
    font-weight: 600;
}

.atd-author__image {
    height: 75px;
    border-radius: 50%;
    width: 75px;
    object-fit: cover;
}

.atd-subheadline {
    font-size: 18px;
    font-weight: 600;
}

.atd-subheadline__l1 {
    font-size: 20px;
    font-weight: 600;
}
.f__row{
    display: flex;
    flex-direction: row;
    gap: 50px;
}

.atd-brand__frame{
  min-height: 400px;
}

.date__wrapper{
    width: 340px;
}
@media only screen and (max-width: 1150px) {
    .date__wrapper{
        width: 270px;
    }
    .gap-50,.time_location__wrapper{
        gap: 15px;
    }
}


@media only screen and (max-width: 768px) {

    .time_location__wrapper{
        flex-direction: column;
        align-items: start;
        gap: 20px;
        justify-content: space-between;
    }
    .btn-prise__wrapper{
        display: flex;
        align-items: center;
    }
    .btn-prise__wrapper .gap-50{
        flex-direction: column;
        gap: 20px;
    }
    .atd-outter-button{
    padding: 10px 20px !important;
    font-size: 20px;
    }
}

@media only screen and (max-width: 530px) {
    .date__wrapper {
        width: 100%;
    }
    .atd-card{
    font-size: clamp(1.9rem, 1.5vw, 2.5rem);}
    .atd-card{
        flex-direction: column;
    }
    .btn-prise__wrapper .gap-50{
        flex-direction: column;
        gap: 20px;
        align-items: normal;
        text-align: center;
        width: 100% !important;
    }
    .starting_price{
        text-align: left;
    }
    .hide_on_mobile{
        display: none !important;
    }
    .flex-sm-column{
        flex-direction: column;
    }
    .d-flex.teilnehmer__Anzahl{
        align-items: start !important;
    }
    .atd-subheadline {
        font-size: 22px !important;
    }
}
@media only screen and (min-width: 530px) {
    .hide_on_desktop{
        display: none !important;
    }
}
.d-flex.teilnehmer__Anzahl{
    gap: 10px;
    align-items: center;
}
.teilnehmer .atd-subheadline{
    min-width: 175px;
}
.gap__10{
    gap: 10px;
}
.content-wrapper section p{
    line-height: inherit;
}
.visible-lg.d-flex{
    display: flex !important;
}
.atd-outter-button{
    padding: 12px 20px;
    cursor: pointer;
    font-weight:bold;
}
</style>
